import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-ink-900 px-4 py-14 sm:px-5 sm:py-20" data-id="element-92" data-mp="1i4znmpm6fims">
      <div className="mx-auto max-w-2xl rounded-3xl border border-brand-500/35 bg-ink-800 px-5 py-10 text-center sm:px-10" data-id="element-93" data-mp="4w1furkch2ib">
        <span aria-hidden="true" className="text-4xl" data-id="element-94" data-mp="9t1pfcgekne6">
          🛡️
        </span>
        <h2 className="mt-4 text-xl font-extrabold uppercase text-white sm:text-3xl" data-id="element-95" data-mp="ev0q2ekrd67f">
          Garantía 7 días — sin preguntas
        </h2>
        <p className="mt-6 text-sm text-gray-300 sm:text-base" data-id="element-96" data-mp="nu4apmzkpto1">
          Abrís los tomos. Los instalás en tu operación.
        </p>
        <p className="mt-2 text-sm text-gray-300 sm:text-base" data-id="element-97" data-mp="slvrx6wuan1i">
          Si en 7 días no es lo que esperabas:
        </p>
        <p className="mt-4 text-xl font-extrabold text-brand-500 sm:text-2xl" data-id="element-98" data-mp="xjfj17emyuav">
          devolución del 100%
        </p>
        <p className="mt-2 text-sm text-gray-300 sm:text-base" data-id="element-99" data-mp="12gxj08aodz6q">
          sin formularios, sin drama, sin esperas.
        </p>
        <p className="mt-6 text-sm text-gray-400" data-id="element-100" data-mp="25rnjv1wi2quc">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </section>;
}